<div class="site-container__footer">
  <div class="flex-container" aria-hidden="true">
    <hr class="separator top" />
  </div>
  <h2>{{headingText}}</h2>
  <p>{{paragraphText1}}</p>
  <p class="margin-bottom-1-5">
    {{paragraphText2}}
  </p>
  <div class="site-container__footer--buttons">
    <a
      routerLink="/{{ firstLink }}"
      class="button primary medium-down-expanded large no-underline"
      >{{ firstLinkText }}</a
    >
    <ng-container *ngIf="secondLink">
      <hr class="separator bottom" />
      <a
        routerLink="/{{ secondLink }}"
        class="button primary hollow medium-down-expanded no-underline"
        >{{ secondLinkText }}</a
      >
    </ng-container>
  </div>
</div>